import { JSX }	from "preact";

import { Dom }					from "ts-base/web/dom";

import * as actionUtil			from "@v3/geko/util/actionUtil";
import { useGuiPermission }		from "@v3/geko/permission/useGuiPermission";
import { GuiPermission }		from "@v3/geko/permission/guiPermission";

import { DecoratedProps }		from "@v3/geko/Decorated";
import { Decor, DecorProps }	from "@v3/geko/Decor";

export type ButtonProps =
	DecoratedProps	&
	Readonly<{
		enabled?:	boolean,
		permission:	GuiPermission,
		action:		() => void,
	}> &
	DecorProps;

export const Button = (props:ButtonProps):JSX.Element => {
	const { customClass, enabled, permission, action }	= props;

	const enabledFlag	=
		useGuiPermission(permission)	&&
		(enabled ?? true);

	return (
		<button
			type="button"
			class={Dom.classes(
				"Button",
				"Decorated",
				"interactive",
				customClass
			)}
			onClick={
				enabledFlag
				?	(ev) => {
						action();
						// attention: removing this will break the click outside handler in Menu
						ev.stopPropagation();
					}
				:	actionUtil.disabledAction}
			disabled={!enabledFlag}
		>
			<Decor {...props}/>
		</button>
	);
};
